module.exports = __webpack_public_path__ + "static/img/twjd-sdo2-2.7acc924.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/twjd-sdo2-2.png
// module id = 150
// module chunks = 0